import { Door, DoorBatteryWarningLevel, Query } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';
import { removeFields } from 'mocks/graphqlMocks/removeFields';

export function mockedGetDoorsForTenantWithLocationsData(
  getDoorsForTenant: Array<Door>
): Pick<Query, 'getDoorsForTenant'> {
  return {
    getDoorsForTenant
  };
}

const fieldsToRemoveFromDoor: (keyof Door)[] = ['locationIds', 'taReaderId', 'supportsOssCards'];

export const mockedGetDoorsForTenantWithLocationsDataUnitTests = mockedGetDoorsForTenantWithLocationsData([
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId0',
      batteryWarningLevel: DoorBatteryWarningLevel.Powered,
      hardwareIdentifier: '66',
      name: 'door 0',
      locations: undefined
    }),
    fieldsToRemoveFromDoor
  ),
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId1',
      batteryWarningLevel: DoorBatteryWarningLevel.Powered,
      hardwareIdentifier: '66',
      name: 'door 1',
      locations: undefined
    }),
    fieldsToRemoveFromDoor
  ),
  removeFields(
    generateMockDoor({
      id: 'mockedDoorId2',
      batteryWarningLevel: DoorBatteryWarningLevel.Powered,
      hardwareIdentifier: '66',
      name: 'door 2',
      locations: undefined
    }),
    fieldsToRemoveFromDoor
  )
]);

export const mockedGetDoorsForTenantWithLocationsDataAdmin = mockedGetDoorsForTenantWithLocationsData(mockDoors);
